export function getColumns(isPublisher:boolean) {
  /*
          CREATE TABLE Clicks (
            campaignId TEXT,
            campaignName TEXT,
            allClicks INTEGER,
            uniqueClicks INTEGER,
            date TEXT, -- Use the ISO 8601 format (YYYY-MM-DD)
            network TEXT,
            credentialsId TEXT,
            country TEXT,
            PRIMARY KEY (campaignId, date, credentialsId)
        )
    ` : 
    `
        CREATE TABLE Clicks (
            campaignId TEXT,
            campaignName TEXT,
            allClicks INTEGER,
            uniqueClicks INTEGER,
            date TEXT, -- Use the ISO 8601 format (YYYY-MM-DD)
            network TEXT,
            credentialsId TEXT,
            country TEXT,
            affiliateId TEXT,
            affiliateName TEXT,
        PRIMARY KEY (affiliateId, date, credentialsId)
        )
  */
  const columns = [
      {
        name: 'Date',
        key: 'date',
        selector: (row:any) => row.date,
        sortable: true,
        wrap: true,
        id:'date',
        searchable:true
      },
      {
          name: 'Network',
          key:'network',
          selector: (row:any) => row.network,
          sortable: true,
          wrap: true,
          searchable:true
        },
        {
          name: 'Country',
          key:'country',
          selector: (row:any) => row.country,
          sortable: true,
          wrap: true,
          searchable: true
        },
        {
          name: 'Campaign',
          key: 'campaignName',
          selector: (row:any) => row.campaignName,
          sortable: true,
          wrap: true,
          searchable:true
        },
        ...(isPublisher ? [] : [{
          name: 'Affiliate',
          key: 'affiliateName',
          selector: (row:any) => row.affiliateName,
          sortable: true,
          wrap: true,
          searchable:true
        }]),
        {
          name: 'All Clicks',
          key: 'allClicks',
          selector: (row:any) => row.allClicks,
          sortable: true,
          wrap: true, 
        },
        {
          name: 'Unique Clicks',
          key: 'uniqueClicks',
          selector: (row:any) => row.uniqueClicks,
          sortable: true,
          wrap: true, 
        }
  ]
  return columns
}